/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Audit_Filter_OkInputs */

const fr_account_audit_filter_ok = /** @type {(inputs: Account_Audit_Filter_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sans action requise`)
};

/**

* @param {Account_Audit_Filter_OkInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const account_audit_filter_ok = /** @type {((inputs?: Account_Audit_Filter_OkInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Audit_Filter_OkInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_account_audit_filter_ok(inputs)
});